export const microscope = () => (
  <path
    d="M18 22h-7a7 7 0 110-14m3 10v4m-3-4h6m-4-6v1h2v-1M14 2a3 3 0 00-3 3v7h6V5a3 3 0 00-3-3z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
